import React, { useEffect, useState } from "react";
import RoleApi from "../../api/RoleApi";
import NewUserApi from "../../api/UserApi";
import { showError, showSuccess } from "../../utils/toastUtils";

function EditDetails({ data, fetchUsers }) {
  const [photoPreview, setPhotoPreview] = useState(null);
  const [roleList, setRoleList] = useState([]);
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [loading, setLoading] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const API_BASE = "http://localhost:5000";

  const [formData, setFormData] = useState({
    roleId: "",
    username: "",
    name: "",
    email: "",
    phone: "",
    location: "",
    avatar: null, // 🔥 YEH ADD KARO
  });

  /* -------------------- LOGIC: REGEX PATTERNS -------------------- */
  const patterns = {
    name: /^[a-zA-Z\s]{3,50}$/,
    email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    phone: /^[6-9]\d{9}$/,
    username: /^[a-zA-Z0-9_]{3,20}$/, // No spaces, only alphanumeric and underscore
  };

  const validateField = (name, value) => {
    if (
      !value &&
      ["roleId", "username", "name", "email", "phone", "location"].includes(
        name,
      )
    ) {
      return `${name} is required`;
    }
    switch (name) {
      case "name":
        return !patterns.name.test(value) ? "Min 3 alphabets required" : "";
      case "email":
        return !patterns.email.test(value) ? "Invalid email address" : "";
      case "phone":
        return !patterns.phone.test(value) ? "Invalid 10-digit number" : "";
      case "username":
        return !patterns.username.test(value)
          ? "Invalid username (3-20 chars, no spaces)"
          : "";
      default:
        return "";
    }
  };

  const getAvatarUrl = (avatar) => {
  if (!avatar) return null;

  if (avatar.startsWith("http://") || avatar.startsWith("https://")) {
    return avatar;
  }

  return `${API_BASE}${avatar.startsWith("/") ? avatar : `/${avatar}`}`;
};
  // Debounce Validation Effect
  useEffect(() => {
    const handler = setTimeout(() => {
      const newErrors = {};
      Object.keys(formData).forEach((key) => {
        const error = validateField(key, formData[key]);
        if (error) newErrors[key] = error;
      });
      setErrors(newErrors);

      const requiredFields = [
        "roleId",
        "username",
        "name",
        "email",
        "phone",
        "location",
      ];
      const allFilled = requiredFields.every(
        (f) => formData[f]?.toString().trim() !== "",
      );
      setIsFormValid(allFilled && Object.keys(newErrors).length === 0);
    }, 500);
    return () => clearTimeout(handler);
  }, [formData]);

  /* -------------------- HANDLERS -------------------- */
  const handleKeyPress = (e) => {
    if (["e", "E", "+", "-", "."].includes(e.key)) e.preventDefault();
  };

  const handleNumberInput = (e, limit) => {
    if (e.target.value.length > limit)
      e.target.value = e.target.value.slice(0, limit);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setTouched((prev) => ({ ...prev, [name]: true }));
  };

  useEffect(() => {
    RoleApi.list().then((res) => res.code === 200 && setRoleList(res.data));
    if (data) {
     if (data.avatar) {
  setPhotoPreview(getAvatarUrl(data.avatar));
} else {
  setPhotoPreview(null);
}
      setFormData({
        name: data.name || "",
        username: data.username || "",
        email: data.email || "",
        phone: data.phone || "",
        location: data.location || "",
        roleId: data.roleId?._id || "",
      });
    }
  }, [data]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isFormValid) return;
    try {
      setLoading(true);
      const form = new FormData();

      Object.keys(formData).forEach((key) => {
        if (formData[key] !== null) {
          form.append(key, formData[key]);
        }
      });

      form.append("id", data._id);

      const res = await NewUserApi.update(form);
      if (res.code === 200) {
        showSuccess(res.message);
        if (fetchUsers) fetchUsers();
        document.getElementById("closeEditOffcanvas").click();
      } else {
        showError(res.message);
      }
    } catch (err) {
      showError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const getValidationClass = (name) => {
    if (!touched[name]) return "form-control";
    return errors[name] ? "form-control is-invalid" : "form-control is-valid";
  };

  return (
    <div>
      <style>{`
        input::-webkit-outer-spin-button, input::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
        input[type=number] { -moz-appearance: textfield; }
      `}</style>

      <div className="offcanvas-header border-bottom">
        <h5 className="fw-semibold">Edit User Details</h5>
        <button
          type="button"
          id="closeEditOffcanvas"
          className="btn-close custom-btn-close border p-1 rounded-circle"
          data-bs-dismiss="offcanvas"
        >
          <i className="ti ti-x" />
        </button>
      </div>

      <div className="offcanvas-body">
        <form onSubmit={handleSubmit}>
          <div className="row">
            {/* Profile Photo */}
            <div className="col-md-12 mb-4">
              <label className="form-label fw-semibold">Profile Photo</label>

              <div className="d-flex align-items-center gap-3">
                <img
  src={
    photoPreview ||
    `https://ui-avatars.com/api/?name=${encodeURIComponent(
      formData.name || "User"
    )}&background=0D8ABC&color=fff&size=160`
  }
  alt="preview"
  className="rounded-circle"
  style={{
    width: "80px",
    height: "80px",
    objectFit: "cover",
    border: "2px solid #e5e5e5",
  }}
  onError={(e) => {
    e.currentTarget.onerror = null;
    e.currentTarget.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(
      formData.name || "User"
    )}&background=0D8ABC&color=fff&size=160`;
  }}
/>

                <input
                  type="file"
                  accept="image/*"
                  className="form-control"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (!file) return;

                    setFormData((prev) => ({ ...prev, avatar: file }));
                    setPhotoPreview(URL.createObjectURL(file));
                  }}
                />
              </div>
            </div>
            {/* Role */}
            <div className="col-md-12 mb-3">
              <label className="form-label">
                Role <span className="text-danger">*</span>
              </label>
              <select
                className={getValidationClass("roleId")}
                name="roleId"
                value={formData.roleId}
                onChange={handleChange}
              >
                <option value="">Select Role</option>
                {roleList.map((item) => (
                  <option key={item._id} value={item._id}>
                    {item.role}
                  </option>
                ))}
              </select>
              {touched.roleId && errors.roleId && (
                <div className="invalid-feedback">{errors.roleId}</div>
              )}
            </div>

            {/* Username */}
            <div className="col-md-6 mb-3">
              <label className="form-label">
                User Name <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className={getValidationClass("username")}
                name="username"
                value={formData.username}
                onChange={handleChange}
              />
              {touched.username && errors.username && (
                <div className="invalid-feedback">{errors.username}</div>
              )}
            </div>

            {/* Name */}
            <div className="col-md-6 mb-3">
              <label className="form-label">
                Name <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className={getValidationClass("name")}
                name="name"
                value={formData.name}
                onChange={handleChange}
              />
              {touched.name && errors.name && (
                <div className="invalid-feedback">{errors.name}</div>
              )}
            </div>

            {/* Email */}
            <div className="col-md-6 mb-3">
              <label className="form-label">
                Email <span className="text-danger">*</span>
              </label>
              <input
                type="email"
                className={getValidationClass("email")}
                name="email"
                value={formData.email}
                onChange={handleChange}
                disabled
              />
              {touched.email && errors.email && (
                <div className="invalid-feedback">{errors.email}</div>
              )}
            </div>

            {/* Phone */}
            <div className="col-md-6 mb-3">
              <label className="form-label">
                Phone <span className="text-danger">*</span>
              </label>
              <input
                type="number"
                className={getValidationClass("phone")}
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                onKeyPress={handleKeyPress}
                onInput={(e) => handleNumberInput(e, 10)}
              />
              {touched.phone && errors.phone && (
                <div className="invalid-feedback">{errors.phone}</div>
              )}
            </div>

            {/* Location */}
            <div className="col-md-12 mb-3">
              <label className="form-label">
                Location <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className={getValidationClass("location")}
                name="location"
                value={formData.location}
                onChange={handleChange}
              />
              {touched.location && errors.location && (
                <div className="invalid-feedback">{errors.location}</div>
              )}
            </div>
          </div>

          <div className="d-flex align-items-center justify-content-end mt-4">
            <button
              type="button"
              className="btn btn-light me-2"
              data-bs-dismiss="offcanvas"
            >
              Cancel
            </button>
            <button
              type="submit"
              className={`btn btn-primary ${!isFormValid || loading ? "disabled" : ""}`}
              disabled={!isFormValid || loading}
            >
              {loading ? "Updating..." : "Save Changes"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditDetails;
